/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 10:57:29
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-22 16:10:20
 */

import { API_PREFIX } from './constant'
import { Request } from './request'


// 列表
export interface PWManagementListParams {
  materialsName?: any
  current?: any
  size?: any
}

export function getPWManagementList(
  params: PWManagementListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/expireddrugs/stopSaleList`,
    method: 'GET',
    params,
  }
}

// 导出
export function getPWManagementExport(
  params: PWManagementListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/expireddrugs/stopSaleList/exportexcel`,
    method: 'GET',
    responseType: 'blob',
    params
  }
}

